module.exports = __webpack_public_path__ + "static/media/empty-fee.9297755a.svg";